export default function SustainableIndustry() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-plant-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">持続可能な産業の創出</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            未来につながる<br />
            新しい産業を
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            環境に配慮した循環型の陸上養殖産業を地域に根付かせることで、<br />
            次世代に引き継げる持続可能な地域産業を創出します。
          </p>
        </div>

        <div className="mb-16">
          <div className="order-2 md:order-1">
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              長期的な視点での産業育成
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              一時的な雇用創出ではなく、地域に根ざした持続可能な産業として育成します。環境負荷を最小限に抑えながら、安定した収益を生み出す事業モデルを構築しています。
            </p>
            <div className="space-y-4">
              <div className="bg-gradient-to-r from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-loop-right-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">循環型システム</h4>
                    <p className="text-sm text-gray-600">水を90%以上再利用し、環境排水ゼロを実現する持続可能なシステム</p>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-calendar-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">安定した生産</h4>
                    <p className="text-sm text-gray-600">天候に左右されない365日安定生産で、継続的な雇用と収益を確保</p>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9]">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-lightbulb-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">技術革新</h4>
                    <p className="text-sm text-gray-600">大学との共同研究により、常に最新技術を導入し競争力を維持</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#F5F9F6] to-white rounded-2xl p-12 border border-[#E8F5E9]">
          <h3 className="text-3xl font-bold text-[#1A2332] mb-8 text-center">地域産業としての成長ビジョン</h3>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">初期段階</h4>
              <p className="text-sm text-gray-600">施設整備と雇用創出<br />地域との信頼構築</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">成長段階</h4>
              <p className="text-sm text-gray-600">生産規模の拡大<br />関連産業との連携</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">発展段階</h4>
              <p className="text-sm text-gray-600">ブランド確立<br />販路の全国展開</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">4</span>
              </div>
              <h4 className="font-semibold text-[#1A2332] mb-2">成熟段階</h4>
              <p className="text-sm text-gray-600">地域産業の核として<br />次世代への継承</p>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-earth-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">環境保全</h4>
            <p className="text-gray-600 leading-relaxed">
              環境負荷を最小限に抑え、自然と共生する産業モデル
            </p>
          </div>
          <div className="text-center">
            <div className="w-20 h-20 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">雇用の安定</h4>
            <p className="text-gray-600 leading-relaxed">
              長期的に安定した雇用を提供し、地域の人口維持に貢献
            </p>
          </div>
          <div className="text-center">
            <div className="w-20 h-20 bg-[#2D7A3E] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-arrow-right-up-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1A2332] mb-3">継続的成長</h4>
            <p className="text-gray-600 leading-relaxed">
              技術革新により競争力を維持し、持続的な成長を実現
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}